<div class="custom-snackbar">
  <div class="snackbar-icon-and-message">
    <h3 [class]="'snackbar-' + data.type + '-header'">
      @switch (data.type) { @case ('success') {
      <div class="snack-bar-icon-wrapper">
        <lucide-icon class="snack-bar-icon" [img]="CircleCheckBig"></lucide-icon>
      </div>
      } @case ('warning') {
      <div mat-list-icon class="snack-bar-icon-wrapper .danger">
        <lucide-icon class="snack-bar-icon" [img]="CircleAlert"></lucide-icon>
      </div>
      } @case ('error') {
      <div mat-list-icon class="snack-bar-icon-wrapper .danger">
        <lucide-icon class="snack-bar-icon" [img]="CircleAlert"></lucide-icon>
      </div>
      } @case('info') {
      <div mat-list-icon class="snack-bar-icon-wrapper .info">
        <lucide-icon class="snack-bar-icon" [img]="Info"></lucide-icon>
      </div>
      } }
    </h3>
    <p class="body-medium-medium" [class]="'snackbar-' + data.type + '-body'">{{ data.message }}</p>
  </div>
  @if (data.actionText) {

  <button class="snack-bar-link" (click)="callAction()" tabindex="-1">{{data.actionText}}</button>
  }

  <button
    class="snack-bar-action-text"
    (click)="closeSnackBar()"
    (keydown)="closeSnackBar()"
    tabindex="-1"
  >
    <lucide-icon class="snack-bar-icon" [img]="X"></lucide-icon>
  </button>
</div>
